import type { DevicePlatform } from '@ghostscreen/contracts';
import { i18n } from '../../i18n/i18n';

/** Product names stay as their makers write them in every language. */
const PRODUCT_NAME: Partial<Record<DevicePlatform, string>> = {
  android_tv: 'Android TV',
  fire_tv: 'Fire TV',
  tizen: 'Tizen',
  webos: 'webOS',
  brightsign: 'BrightSign',
};

export function formatDevicePlatform(platform: DevicePlatform): string {
  if (platform === 'web') return i18n.t('platforms.web');
  if (platform === 'unknown') return i18n.t('platforms.unknown');
  return PRODUCT_NAME[platform] ?? platform;
}
